import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

export function BackButton({ href, children, className = "pl-0 text-slate-500 hover:text-slate-900 -ml-2 mb-6" }: BackButtonProps) {
  const [, setLocation] = useLocation();

  const handleClick = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      setLocation(href);
    }
  };

  return (
    <Button variant="ghost" onClick={handleClick} className={className}>
      <ArrowLeft className="h-4 w-4 mr-2" />
      {children}
    </Button>
  );
}
